{
	"glyphs": {
		"bolt": [
			"..#..",
			".#...",
			".#...",
			"###.#",
			"..##.",
			".##..",
			".#..."
		],
		"drop": [
			"..#..",
			".###.",
			".###.",
			"#####",
			"#####",
			"#####",
			".###."
		],
		"flame": [
			"..#..",
			"..##.",
			".###.",
			".####",
			"####.",
			"####.",
			".##.."
		],
		"gear": [
			".#.#.#.",
			".#####.",
			"#######",
			"##...##",
			"#######",
			".#####.",
			".#.#.#."
		],
		"cross": [
			"..###..",
			"..###..",
			"#######",
			"#######",
			"#######",
			"..###..",
			"..###.."
		],
		"arrow_up": [
			"..#..",
			".###.",
			"#####",
			"..#..",
			"..#.."
		],
		"leaf": [
			"...##",
			"..###",
			".####",
			"####.",
			"###..",
			"##...",
			"#...."
		],
		"spark": [
			"..#..",
			"#.#.#",
			".###.",
			"##.##",
			".###.",
			"#.#.#",
			"..#.."
		]
	}
}
